// extracted by mini-css-extract-plugin
export default {"sectionContainer":"SectionWithInfo_sectionContainer__ST6ux","mainContainer":"SectionWithInfo_mainContainer__W5Dds","infoContainer":"SectionWithInfo_infoContainer__3a43D"};